export default __webpack_public_path__ + "media/images/wing2-23595124a0e097a09cc797d39d9d9556.png";